<template>
  <div class="subscription-page__content">
    <subscription-terms-text></subscription-terms-text>
  </div>
</template>

<script>
export default {
  name: "Subscription",
}
</script>

<style lang="sass">
.subscription-page__content
  width: 100%
  text-align: left
  padding: 20px
  display: flex
  justify-content: center
  background: #FFFFFF

  .terms__content
    max-width: 700px

    h1, h2, h3, h6, p, ul, ol
      margin: revert
      
      li
        margin: inherit
</style>
